import React, { useState } from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Typography } from "@mui/material";
import InputForm from 'app/components/InputForm/InputForm';
import { useNavigate } from 'react-router-dom';
import { REFERRER } from 'app/utils/constants/endPoint';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { requestApi } from 'app/utils/RestApi';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { VisibilityOff } from '@mui/icons-material';
import { Field, Formik } from 'formik';
import { FORM_ERR_MESSAGE } from 'app/utils/constants/validation';
import * as Yup from 'yup';
import { removeToken } from '@jumbo/components/JumboAuthProvider/authHelpers';
import { encryptPayload, ERROR_SERVER_DEFAULT } from 'app/utils/appHelpers';

const FIELD = {
	OLD: 'Kata Sandi Lama',
	NEW: 'Kata Sandi Baru',
	CONFIRM: 'Konfirmasi Kata Sandi',
}

// const patternPwd = new RegExp(/^(?=.*[A-Z])(?=.*[@#!$%^&+=])(?=.*[0-9]).[^\s]{8,30}$/)
const patternPwd = new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/)

const ChgPwdSchema = Yup.object().shape({
	oldPass: Yup.string()
		.required(`${FIELD.OLD} ${FORM_ERR_MESSAGE.REQUIRED}`)
		.min(8, `${FIELD.OLD} minimal 8 karakter.`)
		.max(30, `${FIELD.OLD} maksimal 30 karakter.`)
		.matches(/^[^\s]{8,30}$/, "Kata Sandi tidak boleh mengandung spasi"),
	newPass: Yup.string()
		.min(8, `${FIELD.NEW} min 8 karakter.`)
		.max(30, `${FIELD.NEW} max 30 karakter.`)
		.notOneOf([Yup.ref('oldPass'), null], "Kata Sandi Baru tidak boleh sama dengan Kata Sandi Lama")
		.required(`${FIELD.NEW} ${FORM_ERR_MESSAGE.REQUIRED}`)
		.matches(patternPwd, FORM_ERR_MESSAGE.PWD_PATTERN)
		.max(30, `${FIELD.OLD} max 8 karakter.`),
	confirmPass: Yup.string()
		.min(8, `${FIELD.CONFIRM} min 8 karakter.`)
		.max(30, `${FIELD.OLD} max 30 karakter.`)
		.required(`${FIELD.CONFIRM} ${FORM_ERR_MESSAGE.REQUIRED}`)
		.oneOf([Yup.ref('newPass'), null], "Kata Sandi Baru dan Konfirmasi Kata Sandi tidak Sama")
		.matches(patternPwd, FORM_ERR_MESSAGE.PWD_PATTERN),
});

const MicrositeUbahPassword = (props) => {

	const initialValues = {
		oldPass: '',
		newPass: '',
		confirmPass: ''
	}

	const navigate = useNavigate();

	const [fieldTouched, setFieldTouched] = useState({
		oldPass: false,
		newPass: false,
		confirmPass: false
	});

	const [pwdType, setPwdType] = useState('password');
	const [pwdType2, setPwdType2] = useState('password');
	const [pwdType3, setPwdType3] = useState('password');

	React.useEffect(() => {
		document.querySelector("html").classList.add('overflow-hidden');
	}, []);

	const backHandler = () => {
		navigate(-1)
	};

	const doChangePassword = async (values) => {
		const userdata = localStorage.getItem('userdata')
		let { userLoggedin } = JSON.parse(userdata)
		console.log("values : ", values);
		console.log("ls : ", JSON.parse(userdata));
		console.log("userLoggedin : ", userLoggedin);

		if (!userLoggedin) {
			removeToken()
			return
		}
		await Swal.fire({
			title: 'Mohon Tunggu..',
			timerProgressBar: true,
			didOpen: () => {
				Swal.showLoading()
				const encryptedPayload = encryptPayload({
					email: userLoggedin?.email,
					oldPassword: values.oldPass.trim(),
					newPassword: values.newPass.trim(),
					confirmPassword: values.confirmPass.trim()
				})
				requestApi(REFERRER.CHANGE_PWD, {
					data: {
						data: encryptedPayload
					}
				}).then(({ data }) => {
					Swal.close();
					if (data.status === 'success') {
						if (!userLoggedin.pwdChangedDate) {
							removeToken()
						} else {
							navigate('/micrositeKonfirmasiUbahPassword')
						}
						// browserHistory.replace('micrositeKonfirmasiUbahPassword')
					}
				}).catch(err => {
					console.log(err);
					setTimeout(() => {
						Swal.fire({
							icon: 'warning',
							text: err?.message || ERROR_SERVER_DEFAULT,
							allowOutsideClick: false,
							confirmButtonColor: 'red'
						})
					}, 1000);
				})
			},
			showCloseButton: false,
			showConfirmButton: false,
			allowOutsideClick: false
		})

	};

	const visibilityPwd = React.useCallback(
		() => {
			if (pwdType === 'password') {
				return (
					<VisibilityOff onClick={() => setPwdType('text')} sx={{ fontSize: 25, marginTop: -2 }} />
				)
			}

			return (
				<VisibilityOutlinedIcon onClick={() => setPwdType('password')} sx={{ fontSize: 25, marginTop: -2 }} />
			)
		},
		[pwdType],
	)


	const visibilityPwd2 = React.useCallback(
		() => {
			if (pwdType2 === 'password') {
				return (
					<VisibilityOff onClick={() => setPwdType2('text')} sx={{ fontSize: 25, marginTop: -2 }} />
				)
			}

			return (
				<VisibilityOutlinedIcon onClick={() => setPwdType2('password')} sx={{ fontSize: 25, marginTop: -2 }} />
			)
		},
		[pwdType2],
	)

	const visibilityPwd3 = React.useCallback(
		() => {
			if (pwdType3 === 'password') {
				return (
					<VisibilityOff onClick={() => setPwdType3('text')} sx={{ fontSize: 25, marginTop: -2 }} />
				)
			}

			return (
				<VisibilityOutlinedIcon onClick={() => setPwdType3('password')} sx={{ fontSize: 25, marginTop: -2 }} />
			)
		},
		[pwdType3],
	)


	return (
		<Div className='custompage'>
			<ContentWrapper>
				<Div className='content-padding'>
					{
						localStorage.getItem('temp_token') == null &&
						<Div className='back-icon'>
							<KeyboardBackspaceIcon onClick={backHandler} />
						</Div>
					}
					<Div className='flex-justify-center-title '>
						<Typography fontSize={24} fontWeight={600} color={"#C21B17"} sx={{ marginTop: '15px' }}> Ubah Kata Sandi</Typography>
					</Div>

					<Formik
						validateOnMount
						initialValues={initialValues}
						validationSchema={ChgPwdSchema}
						onSubmit={(values) => {
							doChangePassword(values)
						}}
					>
						{({ errors, values, handleSubmit }) => {
							return (
								<>
									<Div className='mt-2'>
										<Div className='p-4'>

											<Field name="oldPass">
												{({
													field,
													value,
													form: { handleChange },
													meta,
												}) => (
													<>
														<InputForm
															{...field}
															required
															sx={{ mt: 2 }}
															inputLabel={"Kata Sandi Lama"}
															placeholder={"Kata Sandi Lama"}
															onChange={handleChange}
															onBlur={() => {
																if (!fieldTouched.oldPass) {
																	setFieldTouched((prevState) => ({ ...prevState, ['oldPass']: true }))
																}
															}}
															value={value}
															size={'small'}
															type={pwdType2}
															rightIcon={visibilityPwd2()}
														/>
														{(fieldTouched.oldPass && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
													</>
												)}
											</Field>
											<Field name="newPass">
												{({
													field,
													value,
													form: { handleChange },
													meta,
												}) => (
													<>
														<InputForm
															{...field}
															required
															sx={{ mt: 2 }}
															inputLabel={"Kata Sandi Baru"}
															placeholder={"Kata Sandi Baru"}
															type={pwdType}
															onChange={handleChange}
															value={value}
															onBlur={() => {
																if (!fieldTouched.newPass) {
																	setFieldTouched((prevState) => ({ ...prevState, ['newPass']: true }))
																}
															}}
															rightIcon={visibilityPwd()}
															size={'small'}
														/>
														{(fieldTouched.newPass && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
													</>
												)}
											</Field>
											<Field name="confirmPass">
												{({
													field,
													value,
													form: { handleChange },
													meta,
												}) => (
													<>
														<InputForm
															{...field}
															required
															sx={{ mt: 2 }}
															inputLabel={"Konfirmasi Kata Sandi"}
															placeholder={"Konfirmasi Kata Sandi"}
															onChange={handleChange}
															value={value}
															size={'small'}
															onBlur={() => {
																if (!fieldTouched.confirmPass) {
																	setFieldTouched((prevState) => ({ ...prevState, ['confirmPass']: true }))
																}
															}}
															type={pwdType3}
															rightIcon={visibilityPwd3()}
														/>
														{(fieldTouched.confirmPass && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
													</>
												)}
											</Field>
										</Div>
									</Div>

									<Div className='flex-justify-center' sx={{ mt: 2 }}>
										<ButtonStyled
											disabled={(Object.values(errors).length > 0)}
											onClick={handleSubmit}
											btnText={"Simpan"}
											type="submit"
											sx={{ maxWidth: '451px' }}
											preset={"primary"}
										/>
									</Div>
								</>
							)
						}}

					</Formik>

				</Div>
			</ContentWrapper>
		</Div>

	);
};

const mapStateToProps = state => ({
	authMicrosite: state.authMicrosite
});

export default connect(mapStateToProps)(MicrositeUbahPassword);